<template>
  <el-tabs class="group_4" v-model="activeTab" style="margin-top:10px">
    <el-tab-pane name="login">
      <template #label>
        <div class="tab-label" :class="{ 'active-tab': activeTab === 'login' }">微信登录</div>
      </template>
      <div class="login-content">
        <!-- 二维码区域 -->
        <div class="qr-section">
          <div class="qr-title">请使用微信扫一扫登录</div>
          <div class="qr-container">
            <div id="login_container" class="wx-login-container"></div>
            <div v-if="!wxLoginReady" class="qr-loading">
              <span>正在加载二维码...</span>
            </div>
          </div>
        </div>

        <!-- 其他登录方式组件 -->
        <OtherLoginMethods />
      </div>
    </el-tab-pane>
    <el-tab-pane label="注册" name="signup">
      <template #label>
        <div class="tab-label" :class="{ 'active-tab': activeTab === 'signup' }">注册</div>
      </template>
      <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef">
        <el-form-item prop="phone">
          <el-input v-model="registerForm.phone" placeholder="请输入手机号"
            style="width:88%;margin-left:35px;height:60px;margin-top:40px;">
            <template #prepend>+86</template>
            <template #append>
              <span style="cursor:pointer;" @click="sendSmsCode()">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;发送验证码&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input v-model="registerForm.email" class="email_signup" placeholder="请输入验证码"
            style="width:88%;margin-left:35px;height:60px;margin-top:20px;">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="registerForm.password" class="pwd_signup" placeholder="设置您的密码" type="password"
            :show-password="true" style="width:88%;margin-left:35px;height:60px;margin-top:20px;">
            <template #append>
              <span style="cursor:pointer;" @click="register()">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注册&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="agree">
          <span style="font-size:medium;margin-left:100px;">
            <el-checkbox style="transform: scale(1.5);" v-model="registerForm.agree"></el-checkbox>
            &nbsp;&nbsp;我已阅读并同意
            <span style="color:deepskyblue;cursor:pointer;">《服务条款》</span>
            和
            <span style="color:deepskyblue;cursor:pointer;">《隐私协议》</span>
          </span>
        </el-form-item>
      </el-form>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { getScanCode, wechatCallback } from '@/api/user'
import { setToken, removeToken } from '@/store/local/auth'
import { sendSmsCode, register } from '@/api/user';
import OtherLoginMethods from '../components/OtherLoginMethods.vue';
export default {
  components: {
    OtherLoginMethods,
  },
  created() {
    // 初始化微信登录 JS
    this.initWxLoginScript();
    
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    const state = urlParams.get('state')
    if (code && state) {
      const dev = urlParams.get('dev')
      //开发时，确保在8080端口运行
      if (dev == 'true') {
        window.location.replace('http://localhost:8080/store/entry/loginQRCode?code=' + code + '&state=' + state)
        return
      }
      //注意这里的代码，不知道为什么replace到当前页后，实测created和mounted钩子会被执行，所以需要延迟1s执行来确保只发送一次请求
      console.log('检测到微信登录回调，code:', code, 'state:', state);
      const loginStartTime = Date.now();
      setTimeout(() => {
        wechatCallback(code, state).then(
          async response => {
            const { data } = response
            console.log('微信登录回调响应:', data);
            const loginDuration = Date.now() - loginStartTime;
            if (data.code == 1) {
              setToken(response.data.data.token)
              const userInfo = await this.$store.dispatch('user/getInfo')
              const userId = userInfo?.data?.id || userInfo?.data?.account || ''
              localStorage.setItem('userInfo', JSON.stringify(userInfo.data))
              
              // 埋点：用户登录（成功）
              if (this.$tracking && userId) {
                this.$tracking.trackUserLogin(userId, {
                  loginChannel: 'wechat',
                  loginType: 'third_party',
                  loginResult: 'success',
                  loginDuration: loginDuration
                })
              }
              
              console.log('登录成功，跳转到首页');
              this.$router.push('/')
            } else if (data.code == 0) {
              // 埋点：用户登录（失败）
              if (this.$tracking) {
                this.$tracking.trackUserLogin('', {
                  loginChannel: 'wechat',
                  loginType: 'third_party',
                  loginResult: 'fail',
                  failReason: data.msg?.includes('账号') ? 'account_not_exist' : 'other',
                  loginDuration: loginDuration
                })
              }
              
              console.log('登录失败，1秒后刷新页面');
              setTimeout(() => {
                const baseUrl = location.origin + location.pathname
                window.location.href = baseUrl
              }, 1000)
            }
          }
        ).catch(error => {
          console.error('微信登录回调失败:', error);
          const loginDuration = Date.now() - loginStartTime;
          
          // 埋点：用户登录（失败）
          if (this.$tracking) {
            this.$tracking.trackUserLogin('', {
              loginChannel: 'wechat',
              loginType: 'third_party',
              loginResult: 'fail',
              failReason: 'other',
              loginDuration: loginDuration
            })
          }
          
          this.$message.error('登录失败，请稍后重试');
          setTimeout(() => {
            const baseUrl = location.origin + location.pathname
            window.location.href = baseUrl
          }, 2000)
        })
      }, 1000)
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    const state = urlParams.get('state')
    if (!code && !state) {
      this.wxobtain()
    }
  },
  data() {
    return {
      redirect_url: 'https://www.yuugeai.com/store/entry/loginQRCode',
      // redirect_url: 'https://www.yuugeai.com/store/entry/loginQRCode?dev=true',//使用dev字段来从生产环境导回开发环境
      QRCodeUrl: '',
      wxLoginReady: false,
      wxLoginConfig: {
        appid: '',
        scope: 'snsapi_login',
        redirect_uri: '',
        state: '',
        style: 'black',
        href: ''
      },
      activeTab: 'login',
      registerForm: {
        phone: '',
        email: '',
        password: '',
        agree: false
      },
      registerRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少为 6 个字符', trigger: 'blur' }
        ],
        agree: [
          {
            validator: (rule, value, callback) => {
              if (!value) callback(new Error('请同意条款'));
              else callback(); // 验证通过
            }, trigger: 'change'
          }
        ]
      },
    }
  },
  methods: {
    initWxLoginScript() {
      if (typeof window.WxLogin !== 'undefined') {
        return;
      }
      
      // 为了绕过微信登陆的拦截，挺无语的
      !function(e, t) {
        e.WxLogin = function(o) {
          var n = "default";
          !0 === o.self_redirect ? n = "true" : !1 === o.self_redirect && (n = "false");
          var r = t.createElement("iframe")
            , s = (new Date).getTime()
            , a = "/connect/qrconnect?appid=" + o.appid + "&scope=" + o.scope + "&redirect_uri=" + o.redirect_uri + "&state=" + o.state + "&login_type=jssdk&self_redirect=" + n + "&styletype=" + (o.styletype || "") + "&sizetype=" + (o.sizetype || "") + "&bgcolor=" + (o.bgcolor || "") + "&rst=" + (o.rst || "") + "&ts=" + s;
          a += o.style ? "&style=" + o.style : "",
          a += o.href ? "&href=" + o.href : "",
          a += "en" === o.lang ? "&lang=en" : "",
          a += 1 === o.stylelite ? "&stylelite=1" : "",
          a += 0 === o.fast_login ? "&fast_login=0" : "",
          "auto" === o.color_scheme ? a += "&color_scheme=auto" : "dark" === o.color_scheme ? a += "&color_scheme=dark" : "light" === o.color_scheme && (a += "&color_scheme=light"),
          r.src = a,
          r.frameBorder = "0",
          r.allowTransparency = "true",
          r.scrolling = "no",
          r.width = "300px",
          r.height = "400px",
          r.allow = "local-network-access";
          var c = t.getElementById(o.id);
          if (c.innerHTML = "",
          c.appendChild(r),
          e.addEventListener && e.JSON) {
              var i = function(t) {
                  if ("https://open.weixin.qq.com" === t.origin)
                      try {
                          var n = JSON.parse(t.data);
                          if (n && "status" === n.type) {
                              var r = "wxReady" === n.status;
                              r && o.onReady && "function" == typeof o.onReady && o.onReady(r),
                              "wxQRcodeReady" === n.status && o.onQRcodeReady && "function" == typeof o.onQRcodeReady && o.onQRcodeReady()
                          }
                      } catch (t) {
                          e.console && "function" == typeof e.console.log && e.console.log("wxLogin postMessage error", t)
                      }
              };
              e.addEventListener("message", i, !1);
              var l = !1;
              o.onCleanup = function() {
                  !l && e.removeEventListener && (e.removeEventListener("message", i, !1),
                  l = !0)
              }
          }
        }
      }(window, document);
    },
    wxobtain() {
      getScanCode(this.redirect_url).then(response => {
        const { data } = response
        if (data && data.data && data.data.url) {
          try {
            let urlString = data.data.url;
            const url = new URL(urlString);

            this.wxLoginConfig.appid = url.searchParams.get('appid') || '';
            this.wxLoginConfig.scope = url.searchParams.get('scope') || 'snsapi_login';
            
            // redirect_uri 需要编码，searchParams.get() 会自动解码，所以需要重新编码
            const redirectUri = url.searchParams.get('redirect_uri');
            if (redirectUri) {
              this.wxLoginConfig.redirect_uri = encodeURIComponent(redirectUri);
              this.redirect_url = redirectUri; // 保存解码后的值用于后续使用
            } else {
              this.wxLoginConfig.redirect_uri = encodeURIComponent(this.redirect_url);
            }
            
            this.wxLoginConfig.state = url.searchParams.get('state') || `${Math.random()}`;
            this.wxLoginConfig.style = url.searchParams.get('style') || 'black';
            this.wxLoginConfig.href = 'data:text/css;base64,LmltcG93ZXJCb3ggLm5vcm1hbFBhbmVse21hcmdpbi10b3A6IDcwcHg7fQouaW1wb3dlckJveCAucXJjb2RlIHt3aWR0aDogMTgwcHg7Ym9yZGVyLWNvbG9yOiNDNUUxRkY7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQoucWxvZ2luX21vZCB7bWFyZ2luLXRvcDo0NXB4fQouaW1wb3dlckJveCAuc3RhdHVze3RleHQtYWxpZ246Y2VudGVyfQ==';
            // this.wxLoginConfig.href = 'data:text/css;base64,LmltcG93ZXJCb3ggLm5vcm1hbFBhbmVse21hcmdpbi10b3A6IDE1cHg7fQouaW1wb3dlckJveCAucXJjb2RlIHt3aWR0aDogMTgwcHg7Ym9yZGVyLWNvbG9yOiNDNUUxRkY7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQoucWxvZ2luX21vZCB7bWFyZ2luLXRvcDo0NXB4fQ==';

            
            // 初始化微信登录
            this.initWxLogin();
          } catch (e) {
            console.error('解析二维码URL失败:', e);
            console.error('原始URL:', data.data.url);
            this.$message.error('获取二维码失败，请稍后重试');
          }
        }
      }).catch(error => {
        console.error('获取二维码失败:', error);
        this.$message.error('获取二维码失败，请稍后重试');
      })
    },
    initWxLogin() {
      // 确保 WxLogin 已加载
      if (typeof WxLogin === 'undefined') {
        console.error('WxLogin 未加载，请检查脚本引入');
        this.$message.error('微信登录初始化失败');
        return;
      }

      this.$nextTick(() => {
        // 清空容器
        const container = document.getElementById('login_container');
        if (!container) {
          console.error('找不到登录容器');
          return;
        }
        
        container.innerHTML = '';
        
        // 初始化微信登录
        try {
          new WxLogin({
            self_redirect: false,
            id: "login_container",
            appid: this.wxLoginConfig.appid,
            scope: this.wxLoginConfig.scope,
            redirect_uri: this.wxLoginConfig.redirect_uri,
            state: this.wxLoginConfig.state,
            style: this.wxLoginConfig.style,
            href: this.wxLoginConfig.href
          });
          this.wxLoginReady = true;
        } catch (error) {
          console.error('微信登录初始化失败:', error);
          this.$message.error('微信登录初始化失败');
        }
      });
    },
    OpenQRCodeHtml() {
      window.location.replace(this.QRCodeUrl)
    },
    sendSmsCode() {
      sendSmsCode({ mobile: this.registerForm.phone, scene: 'ZC' }).then(response => {
        if (response.data.code == 1) this.$message.success('验证码已发送，请注意查收')
      })
    },
    register() {
      this.$refs.registerFormRef.validate((valid) => {
        if (!valid) return
        register({ account: this.registerForm.phone, password: this.registerForm.password, sms_code: this.registerForm.email, terminal: 0 })
          .then(response => {
            console.log(response)
          })
      })
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
::v-deep .el-form-item__error {
  left: 40px;
}

::v-deep .el-tabs__content {
  position: relative;
  margin-top: -2px;
  padding: 0px;
  min-height: 405px;
  height: auto;
  border: none;
  border-top: none;
  border-radius: 0px 0px 20px 20px;
  background: transparent;
  overflow: visible;
}

::v-deep .el-tabs__header {
  border-bottom: none;
  background: transparent;
}

::v-deep .el-tabs__item {
  width: 50%;
  height: 100%;
  line-height: 62px;
  text-align: center;
  font-size: x-large;
}

::v-deep .el-tabs__nav {
  display: flex;
  width: 100%;
  height: 62px;
  position: relative;
}

::v-deep .el-tabs__nav::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: rgba(101, 101, 135, 0.40);
}

::v-deep .el-tabs__item:nth-child(1) {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  position: relative;
}

::v-deep .el-tabs__item:nth-child(1)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
}

::v-deep .el-tabs__item:nth-child(1).is-active {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 20px 0px;
  clip-path: polygon(0 0, 100% 0, 100% 50%, 50% 100%, 0 100%);
}

::v-deep .el-tabs__item:nth-child(1).is-active::after {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
}

::v-deep .el-tabs__item:nth-child(2) {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 50%, 50% 0, 100% 50%, 100% 100%, 0 100%);
  margin-left: 0px !important;
  position: relative;
}

::v-deep .el-tabs__item:nth-child(2)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
}

::v-deep .el-tabs__item:nth-child(2).is-active {
  width: 50%;
  background: none;
  border: none;
  border-radius: 20px 20px 0px 20px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 100%, 0 50%);
  margin-left: 0px !important;
}

::v-deep .el-tabs__item:nth-child(2).is-active::after {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
}

::v-deep .el-input-group__append {
  border-radius: 0px 18px 18px 0px;
  font-size: large;
}

::v-deep .el-input-group__prepend {
  border-radius: 18px 0px 0px 18px;
  font-size: x-large;
}

::v-deep .el-input__inner {
  height: 60px;
  font-size: large;
}

::v-deep .email_login .el-input__inner {
  border-radius: 18px 0px 0px 18px;
}

::v-deep .email_login .el-input-group__append {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
}

::v-deep .email_signup .el-input__inner {
  border-radius: 18px;
}

::v-deep .pwd_signup .el-input__inner {
  border-radius: 18px 0px 0px 18px;
}

::v-deep .pwd_signup .el-input-group__append {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  color: white;
}

.tab-label {
  font-size: x-large;
  font-weight: normal;
  color: #333;
}

.active-tab {
  font-weight: bold;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

/* 登录内容容器 */
.login-content {
  padding: 0 35px;
  background: transparent;
  position: relative;
  z-index: 5;
}

/* 二维码区域 */
.qr-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
}

.qr-title {
  font-size: 18px;
  color: #666;
  margin-bottom: 20px;
  text-align: center;
}

.qr-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 200px;
  position: relative;
  /* background: white; */
}

.wx-login-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

/* 隐藏微信登录二维码中的文字 */
.wx-login-container ::v-deep .impowerBox .title {
  display: none !important;
}

.wx-login-container ::v-deep .impowerBox .info {
  display: none !important;
}

.qr-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: #666;
  font-size: 14px;
  text-align: center;
}

.qr-loading span {
  display: block;
  text-align: center;
}
</style>